const value = {
  title: 'Аналитика',
  noResultsMessage: 'Скоро тут появятся график с данными',
  noResults: 'Пока ничего нет',
  resultsByProject: 'Результативность обучения по проектам',
  exportReports: 'Экспорт отчетов',
  exportEmployeesReport: 'Отчет по пользователям',
  exportUnitsReport: 'Отчет по юнитам',
  exportProjectReport: 'Экспорт отчёта проекта',
  exportUserReport: 'Экспорт отчета',
  employees: 'Человек',
  notStarted: 'Не начали',
  inProgress: 'В процессе',
  completed: 'Завершили',
  ratingTitle: 'Рейтинг:',
  projects: 'Проекты',
  users: 'Пользователи',
  userUnitProgress: 'Прогресс по юнитам',
  userUnitStatuses: {
    notStarted: 'Новый',
    inProgress: 'В процессе',
    completed: 'Завершен',
    failed: 'Не сдан',
  },
  ratings: {
    noData: 'Нет данных',
    rowsPerPage: 'Строк на странице:',
    of: 'из',
    nextPage: 'Следующая страница',
    previousPage: 'Предыдущая страница',
    projects: {
      name: 'Проект',
      averageProgress: 'Прогресс по юнитам',
      usersCount: 'Пользователи',
      averageScore: 'Баллы',
      searchPlaceholder: 'Поиск по названию проекта',
    },
    users: {
      userName: 'Пользователь',
      projectRoles: 'Роли',
      projects: 'Проекты',
      progress: 'Прогресс по юнитам',
      score: 'Баллы',
      unitsPassed: 'Юнитов пройдено',
      searchPlaceholder: 'Поиск по имени пользователя',
    },
  },
  metricsHistory: {
    title: 'История метрик',
    userTitle: 'История прогресса',
    createSnapshot: 'Создать снимок',
    noData: 'Нет данных истории',
    tabs: {
      averageProgress: 'Ср. прогресс',
      averageScore: 'Ср. балл',
      activeUsers: 'Активные',
      completedUsers: 'Завершившие',
    },
    userTabs: {
      importantScore: 'Баллы',
      progressPercent: 'Прогресс',
    },
  },
};

export default value;
